export default {
  "redPacketRecord.title": "红包雨记录",
  "redPacketRecord.column.no": "#NO",
  "redPacketRecord.column.userNo": "用户编号",
  "redPacketRecord.column.email": "邮箱",
  "redPacketRecord.column.title": "标题",
  "redPacketRecord.column.type": "类型",
  "redPacketRecord.column.amount": "金额",
  "redPacketRecord.column.claimTime": "领取时间",

  "redPacketRecord.column.createTime": "创建时间",
  "redPacketRecord.search.userNo": "用户编号",
  "redPacketRecord.tooltip.copy.userNo": "复制用户编号: {text}",
  "redPacketRecord.tooltip.showUserDetails": "显示用户详情",
  "redPacketRecord.copy.success": "复制成功",
};